module.exports = __webpack_public_path__ + "files/69db1eba34ebc2a4995be5666f7622ca.png";